import { FDSColors } from '@fountain/fds-tokens';
import { ThemeOptions } from '@material-ui/core/styles';
import { ApplicantBrandColors } from 'api-clients/monolith';

interface CommonPalette {
  black: string;
  blue100: string;
  blue200: string;
  blue400: string;
  blue500: string;
  blue50: string;
  blue600: string;
  gray100: string;
  gray200: string;
  gray300: string;
  gray400: string;
  gray500: string;
  gray600: string;
  gray700: string;
  gray800: string;
  gray900: string;
  green100: string;
  green400: string;
  green600: string;
  green800: string;
  orange100: string;
  orange200: string;
  orange400: string;
  orange600: string;
  orange800: string;
  red100: string;
  red400: string;
  red600: string;
  red800: string;
  white: string;
}

declare module '@material-ui/core/styles/createPalette' {
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface CommonColors extends CommonPalette {}
}

const palette: ThemeOptions['palette'] = {
  common: {
    black: FDSColors.black,
    blue100: FDSColors.blue100,
    blue200: FDSColors.blue200,
    blue400: FDSColors.blue400,
    blue500: FDSColors.blue500,
    blue50: FDSColors.blue50,
    blue600: FDSColors.blue600,
    gray100: FDSColors.gray100,
    gray200: FDSColors.gray200,
    gray300: FDSColors.gray300,
    gray400: FDSColors.gray400,
    gray500: FDSColors.gray500,
    gray600: FDSColors.gray600,
    gray700: FDSColors.gray700,
    gray800: FDSColors.gray800,
    gray900: '#141414',
    green100: FDSColors.green100,
    green400: FDSColors.green400,
    green600: FDSColors.green600,
    green800: FDSColors.green800,
    orange100: FDSColors.orange100,
    orange200: FDSColors.orange200,
    orange400: FDSColors.orange400,
    orange600: FDSColors.orange600,
    orange800: FDSColors.orange800,
    red100: FDSColors.red100,
    red400: FDSColors.red400,
    red600: FDSColors.red600,
    red800: FDSColors.red800,
    white: FDSColors.white,
  },
  error: { main: FDSColors.red400 },
  primary: { main: FDSColors.blue400 },
  secondary: { main: FDSColors.gray600 },
  text: {
    disabled: FDSColors.gray500,
    hint: FDSColors.gray400,
    primary: FDSColors.gray800,
    secondary: FDSColors.gray600,
  },
};

export const buildBrandPalette = (
  colors: ApplicantBrandColors,
): ThemeOptions['palette'] => ({
  ...palette,
  primary: { main: colors.primary },
});
